export default {
  abnormal: "异常",
  AbnormalFlow: "异常流向",
  accept: "接受",
  account: "登录账户",
  account_balances: "账户余额",
  account_name: "账户名",
  account_type: "收款账户类型",
  accountInformation: "账号信息",
  accounting: "财务名称",
  accounting_amount: "核算金额",
  accountNum: "账号",
  AccountOpeningDate: "开户日期",
  active: "活跃",
  activeStatus: "活跃状态",
  actual_amount: "业务申请金额",
  actual_currency: "业务申请币种",
  actual_receipt: "实收",
  actual_weight: "实际重量",
  actualChargeWeight: "实际重",
  add: "新增",
  addContract: "新增合同",
  additional_information: "附加信息",
  addPath: "路由管理",
  addReceipt: "添加签收单",
  Address2: "营业执照/身份证地址(中文)",
  addressError: "地址错误",
  addressError_rate: "地址错误率",
  addTo: "添加",
  addUser: "添加用户",
  addValueService: "新增增值服务",
  after: "后",
  agent: "代理管理",
  agent_claim: "责任方理赔",
  agent_logo: "代理LOGO",
  agentFee: "COD代理手续费",
  agentName: "代理名称",
  agentProcessed: "待代理处理",
  agentT: "代理",
  AgentTrajectory: "代理轨迹",
  agentTypes: "代理类型",
  agree: "同意",
  air: "航线管理",
  air_agent: "空运代理",
  air_freight: "空运运费",
  air_price: "机场装卸费",
  air_transport: "空运",
  airFreight: "空运费",
  airIncome: "空运收入",
  airLine: "航线",
  airlineCompany: "航空公司",
  airlineMsg: "航司信息",
  airManagement: "空运管理",
  airPackingList: "空运中港单列表",
  airPackingNew: "新建空运中港单",
  airPerformance: "空运绩效",
  airport: "目的机场",
  airport_code: "机场代号",
  airport_fee: "广州机场费用",
  airport_name: "机场名称",
  airport_t: "机场",
  airportCost: "机场费用",
  airportManage: "机场管理",
  airShippingMark: "空运唛头标签",
  airWaybillList: "空运提单列表",
  airWaybillNumber: "空运单号",
  AliExpress: "速卖通",
  aliexpressCode: "速卖通 ID",
  alipay: "支付宝",
  alipay_name: "名称",
  all: "全部",
  allow: "允许",
  allow_arrive: "目的国",
  allow_depart: "起运国",
  allow_status: "容许状态",
  alreadConfirm: "已确认重量",
  already_listed_number: "上架库存",
  alreadyPick: "已取件",
  amazon: "亚马逊",
  AmazonEasyship: "亚马逊Easyship",
  AmazonSelfship: "亚马逊selfship",
  amount: "账单金额",
  amount_actual: "实际",
  amount_receivable: "应收金额",
  amount_refunded: "应退金额",
  analysis: "时效",
  analysis1: "分析",
  analysisDate: "分析日期",
  analysisResult: "结果列表",
  apod: "已签收",
  appConsignorTime: "预约交件时间",
  Appendix: "附件",
  application: "申请",
  application_reason: "申请原因",
  Application_time: "申请时间",
  Appointment: "预约派送时间",
  appointment_t: "预约派",
  appointmentDate: "预约日期",
  appointmentNumber: "预约号",
  appointmentPieces: "预约派送列表",
  apportion: "成本分摊",
  approval_opinion: "审批意见",
  approval_remark: "审批备注",
  approval_time: "审批时间",
  approver: "审批人",
  area: "地区",
  arrears: "欠款金额",
  arrival_date: "到达目的港时间",
  arrival_HK: "到港",
  arrival_HK_date: "到香港时间",
  arrival_time: "到仓",
  arrival_time_rate: "到仓率",
  arrival_warehouse: "入仓时间",
  arrivalTime: "抵港时间",
  arrive: "到达",
  ARRIVE_DATE: "到达目的港时间",
  AssistContent: "协作内容",
  assistDepartment: "部门",
  assistOrder: "协作单",
  assistPerson: "协作人",
  assistPlatform: "协作平台",
  audit: "审核者",
  audit_process: "审核流程",
  audit_time: "审核时间",
  auditOrder: "审核",
  auth: "权限管理",
  auto_acquire: "自动获取",
  AvailableInventory: "可用库存",
  avatar: "头像",
  b2b_audit: "B2B审核",
  b2b_feright: "B2B报价规则",
  b2b_prefix: "唛头代码",
  b2b_remain_ticket: "B2B剩余票数",
  B2B_SUBPACKAGE: "B2B分包",
  b2b_warehouse: "B2B仓库管理",
  b2bBill: "B2B 账单",
  b2bClient: "客户",
  b2bDetails: "B2B 出货明细",
  b2bName: "账单名称",
  B2bOrderNo: "B2B订单号",
  b2boutbound_number: "B2B出货次数",
  b2bPackingList: "B2B中港单列表",
  back_warehouse: "回仓时效",
  back_warehouse_num: "回仓数量",
  bag: "袋子",
  bagCode: "袋子号码",
  Bagging: "装袋",
  bagList: "袋子列表",
  bagManagement: "装袋管理",
  bagNum: "袋子号",
  bagsNum: "袋子数量",
  bagTime: "装袋时间",
  balance_amount: "待付余额",
  bank: "银行名称",
  bank1: "银行卡",
  bank_account: "开户银行",
  bank_accounts: "银行账户",
  bank_address: "银行地址",
  bank_code: "收款账户",
  bank_name: "收款银行",
  bankDetails: "银行详细信息",
  bankInfo: "银行信息",
  BankTransfer: "银行转账",
  baoguan: "报关方式",
  safetyServicePlan: "保险方案",
  declareCustoms: "报关",
  barCode: "商品条码",
  barcode_t: "条形码",
  barPhase: "拦截阶段",
  basic_information: "基本信息",
  batch: "批量",
  batch_claim: "批量发起追赔",
  batchAudit: "批量审核",
  battery: "是否带电",
  beenShip: "已经发货",
  BeforeManifest: "未创建派送单",
  BeforeOverseaOutbound: "未扫描140",
  BeforeOverseaWarehouse: "已出库",
  BeforePackage: "未装袋",
  BeforePackageOutboun: "装袋未出库",
  begin_price: "首重费用",
  belongDepartment: "所属部门",
  big_weight: "最大重量",
  bigImg: "大图",
  bill: "小包账单",
  bill1: "账单",
  bill_close_account_issuing: "出单金额",
  bill_close_account_issuing_charge: "手续费",
  bill_close_account_issuing_confirm: "应退",
  bill_create: "生成应退账单",
  bill_name: "账单名称",
  bill_number: "账单号",
  bill_proceeds_issuing: "出单金额",
  bill_proceeds_issuing_charge: "手续费",
  bill_proceeds_issuing_confirm: "实收金额",
  bill_receivable: "生成应收账单",
  bill_type: "账单状态",
  billBranch: "小包账单(分公司)",
  Billed: "已经出账单",
  billFailed: "计费失败",
  billFee: "提单清关费",
  billForecast: "提单预报列表",
  BillInformation: "提单信息",
  Billing: "计费",
  billing_price: "计费单价",
  billing_unit: "计费单位",
  billingCurrency: "计费币种",
  billingMethod: "出单方式",
  billPackageFee: "提单内拼货费",
  billSuccess: "计费成功",
  billWeight: "提单重量费",
  bind: "绑定",
  bindContract: "合同",
  bindCurrency: "绑定货币",
  bindDep: "绑定部门",
  bindFreight: "报价",
  bindRole: "绑定角色",
  bindRoles: "绑定角色/部门",
  blindFactionSLA: "盲派SLA",
  body: "主体",
  booking_number: "订舱号",
  booking: "订舱",
  bounceBack: "退件重派",
  boxOrder: "箱单",
  branch: "运费匹配-分公司",
  branch_bill: "分公司小包账单",
  branch_cod: "分公司COD明细",
  branch_cod_list: "分公司COD应收",
  branch_cod_refund: "分公司COD应退",
  branch_finance: "分公司财务",
  branch_name: "分公司名称",
  branch_shipment: "分公司小包明细",
  branchCuditConfiguration: "分公司理赔配置",
  branchOffice: "分公司",
  btn_lis: "按钮组",
  btn_name: "按钮名称",
  bubble_weight: "泡重方式",
  BulkAdd: "批量添加",
  bulletinBoard: "公告栏",
  bulletinContent: "公告内容",
  bulletinExtend: "公告附件",
  bulletinSys: "发布系统",
  bulletinTime: "发布时间",
  bulletinTitle: "公告标题",
  business: "业务",
  business_license: "营业执照",
  businessTypes: "业务类型",
  byCallCenter: "待Call Center处理",
  byCustomer: "待客户处理",
  byOverseasWarehouse: "待海外仓库处理",
  byOverseasWarehouseListed: "待海外仓库上架",
  byOverseasWarehousePicking: "待海外仓库拣货",
  byService: "待客服处理",
  c_pod: "尾程签收天数",
  cabinet_type: "柜型",
  cabinetNumber: "柜号",
  calculation: "计算",
  callBack: "关税回调",
  called_times: "无人接听次数",
  can: "可以",
  cancel: "取消",
  cancel_claim: "撤销理赔",
  canShip: "可以发货",
  car_rental: "租车费",
  cargo_number: "货件编号",
  cargoNumber: "货件编号",
  cargoNumber1: "货件编号",
  carrier_code: "运输渠道",
  carrier_number: "承运单号",
  case_number: "箱数",
  caseNumber: "箱数",
  cashPay: "现付",
  category: "货物品类",
  category_name: "货物名称",
  category_t: "类目",
  change_amount: "收支金额",
  changeOrder: "换单",
  channel: "渠道管理",
  channel_code: "渠道代码",
  channel_logo: "渠道Logo",
  channel_name: "渠道名称",
  channelCost: "成本配置",
  channelCostRate: "成本汇率",
  charge: "收费",
  charge_params: "计费重量",
  charge_volume: "体积重量",
  charged_details: "带电明细",
  charging_volume: "计费体积",
  check_amount: "核销金额",
  check_amount_currency: "核销货币",
  check_bill_number: "COD账单号",
  check_time: "核销时间",
  check_weight: "入库重量",
  checkFile: "选择文件",
  checkFreight: "验证",
  child: "子级",
  china: "中国",
  Chinese: "中文",
  city: "城市管理",
  city_code: "城市代码",
  city_mapping: "城市映射",
  city_name: "城市名称",
  city_t: "城市",
  claim: "理赔",
  claim_acceptance: "受理索赔",
  claim_agree: "理赔接受",
  claim_application: "发起追赔",
  claim_fee: "理赔账单",
  claim_list: "理赔列表",
  claim_list_branch: "分公司理赔",
  claim_management: "理赔管理",
  claim_pay: "赔付",
  claim_pool: "理赔池",
  claim_standard: "运费+申报价值",
  claim_t: "申明",
  claim_weight: "申明重量",
  clearagent: "清关代理",
  clearance: "清关",
  clearance_agent: "清关名称",
  clearance_agent1: "清关代理",
  clearance_agent_params: "清关账号",
  clearance_date: "清关时间",
  clearance_fee_type: "清关费类型",
  clearance_time: "清关",
  clearanceCost: "清关成本",
  clearanceFee: "清关费",
  client: "客户管理",
  client_amount: "客户申请金额",
  client_currency: "客户申请币种",
  clientCompany: "卖家平台",
  clientFreight: "客户报价审核",
  clientInformation: "客户信息",
  clientName: "客户账号",
  clientDisplay: "客户名",
  close: "关闭",
  cnName: "中文名称",
  cod: "COD出货明细",
  cod_1_time: "出单时间",
  cod_9_time: "结算时间",
  cod_agent_rate: "收款汇率",
  cod_amount: "代收金额",
  cod_amount_ratio: "COD金额比例",
  cod_assign: "客户/代理名称",
  cod_bank_fee: "cod银行手续费",
  cod_client_rate: "结算汇率",
  cod_collection: "COD收款",
  cod_currency: "COD 货币",
  cod_details: "账单明细",
  cod_money_back: "COD回款",
  cod_ncnd: "收款",
  cod_ncnd_1_time: "出单时间",
  cod_ncnd_9_time: "收款时间",
  cod_ncnd_status: "收款状态",
  cod_number: "总票数",
  cod_settlement: "COD结算",
  cod_status: "结算状态",
  cod_type: "代收类型",
  cod_type_txt: "COD类型",
  codAbnormal: "COD异常件",
  codAmount: "COD 金额",
  code: "代码",
  code_rules: "验证",
  codList: "COD应收账单",
  codNAme: "账单名称",
  codRate: "COD汇率",
  codRefund: "COD应退账单",
  codRefundRate: "COD应退汇率",
  codTypes: "账单类型",
  coll: "到付",
  collapse: "收起",
  collection: "收取",
  collection_t: "代收",
  combinedEnquiry: "合包查询",
  commodityValue: "商品价值",
  company: "服务项目",
  company1: "服务项目",
  company_name: "公司名",
  company_t: "公司",
  complete: "完成",
  completed: "已完成",
  configuration: "配置",
  configuration_item: "配置项",
  confirm: "确认",
  confirm_pay: "确定打款",
  confirm_time: "确认时间",
  confirmOrder: "确认",
  confirmPwd: "确认密码",
  confirmWeight: "确认重量",
  consignor: "交件人名称",
  consignorAddress: "交件人地址",
  consignorPhone: "交件人电话",
  contact: "收货人",
  contactEmail: "客户邮箱",
  contain: "含有",
  content: "内容",
  continueWeight: "续重信息",
  contraband: "违禁品",
  contraband_code: "编码",
  contraband_description: "描述",
  contract_account: "合同账号",
  contract_end_time: "合同结束日期",
  contract_remark: "合同备注",
  contract_src: "合同文件",
  contract_start_time: "合同开始日期",
  contract_title: "优选合同抬头",
  contract_type: "合同协议",
  contractHeader: "合同抬头",
  contractInfo: "合同信息",
  Conversion: "换算",
  convert: "城市映射",
  convert_rate: "体积常数",
  ConvertedUdollars: "折算成美金",
  cope: "应付",
  copy: "复制",
  correctOrderNumber: "请输入正确的订单号",
  correspond: "对应",
  cost: "分摊费用",
  cost_fee: "成本费用",
  cost_item_txt: "二级费用",
  cost_share: "分摊成本",
  cost_t: "费用",
  costEntry: "录入成本",
  costing: "财务成本",
  costName: "成本报价名称",
  countdown: "倒计时",
  country: "国家管理",
  country_code_type: "类型",
  country_code_validation: "规则",
  country_t: "国家",
  countryCode: "国家代码",
  countryCurrency: "国家货币",
  countryName: "国家名称",
  countryTimezone: "国家时区",
  countryZone: "国家区号",
  courier: "派送商",
  createBill: "生成账单",
  createPickup: "创建拣货单",
  createTime: "创建时间",
  createUser: "创建人",
  credit_limit: "信用额度",
  creditLimit: "信用额度",
  criticalValue: "中位值",
  cross_port: "过港",
  CTNS: "件数",
  currency: "货币汇率管理",
  currency_t: "币种",
  currencyCode: "货币代码",
  currencyCode1: "货币代码",
  currencyEnName: "英文名称",
  currencyName: "货币名称",
  currencyType: "货币类型",
  current_approver: "当前审批人",
  CurrentState: "当前状态",
  customer_contract: "客户合同",
  customer_group: "客户组别",
  customer_nums: "本月客户数",
  customer_rate: "跟进客户增加量",
  customer_report: "完整海关报表",
  customerCompanyName: "客户公司名",
  customerInt: "客户拦截",
  CustomerNote: "客户备注",
  customerProcessed: "待客户处理",
  customerServerBull: "客服看板",
  customerWait: "待确认出库",
  customs_fee: "报关费",
  customsBill: "过港单号",
  CustomsClearer: "清关商",
  customsFee: "海关收费",
  CustomsHold: "海关扣留",
  Customsinfo: "报关资料",
  CustomsInspection: "海关检查",
  CustomsReleased: "国内清关完成",
  cycle: "周期",
  danzhengUser: "证单员",
  data: "数据",
  date: "日期",
  day: "天",
  dayNumber: "天数",
  dayShipment: "每日出货",
  daysRemaining: "剩余天数",
  ddp_price: "DDP费用",
  ddx: "代收税款方式",
  deadline: "截止时间",
  declared_value: "最低申报价值",
  declared_value_rate: "申报价值比率",
  DeclaredValue: "申报价值",
  OriginalDeclaredValue: "原申报价值",
  deductExpenses: "抵扣费用",
  delete: "删除",
  deleteOrder: "删除订单",
  deliver: "发货",
  deliver_address: "发货地址",
  deliver_goods_number: "出货产品数量",
  delivery: "派送",
  delivery_agent: "代理账号",
  delivery_agent_tracker: "代理轨迹",
  delivery_method: "下港方式",
  delivery_mode: "发货模式",
  deliveryAddress: "送仓地址",
  deliveryCompany: "交付商",
  deliveryCost: "交付费",
  deliveryCost_t: "派送费",
  deliveryCostQuery: "派送费用查询",
  deliveryFee: "送货费",
  deliveryTime: "派送时间",
  DeliveryTimes: "派送次数",
  delService: "B2B客服",
  deName: "部门名称",
  deParent: "上级",
  depart_date: "离港时间",
  department: "组织架构",
  DEPARTURE_TIME: "起飞时间",
  departureAirport: "起运机场",
  dept_date: "预计离港时间",
  dept_HK: "离港",
  des_goods: "商品",
  deSc: "描述",
  destinationAirport: "目的机场",
  destinationCountry: "目的地国家",
  destroy: "销毁",
  destroy_price: "销毁费用",
  detail: "详情",
  dingcangCompany: "订舱公司",
  disable: "禁用",
  disagree: "不同意",
  discount: "折扣",
  discount_allowance: "折扣折让",
  distribution_agent: "派送代理",
  disWarehouse: "配货仓",
  division: "财务分区",
  division_txt: "财务分区",
  doc: "文档",
  document_fee: "资料费",
  documentClass: "文档分类",
  documentClassName: "分类名称",
  documentContent: "文档内容",
  documentList: "文档列表",
  documentManagement: "文档管理",
  documentName: "文档名称",
  documents: "单证（套数）",
  domestic: "国内",
  DomesticDelivery: "国内发货",
  doubleAdd: "新建 B2B 订单",
  doubleAmount: "总价",
  doubleClear: "双清单",
  doubleFeright: "完善信息",
  doubleInfo: "货物明细",
  doubleList: "B2B 订单",
  doublePrice: "单价",
  gross: "毛",
  doubleweight: "毛重",
  down: "下架",
  download: "下载",
  download_tem: "下载模板",
  downloadLocationInfo: "下载库位修改模板",
  driver_status: "司机可用状态",
  duty_rate: "关税税率",
  each: "每个",
  eachKG: "每KG",
  ECommercePacket: "电商杂货渠道小包",
  ECommerChannel: "电商杂货渠道",
  editLocationInfo: "修改库位数据",
  electricity_fee: "电放费",
  ElectricityPCS: "带电件数",
  email: "邮件",
  email_format: "邮箱格式不正确",
  email_subject: "邮件主题",
  En: "(英文)",
  enable: "启用",
  enableTime: "启用时间",
  end: "结束",
  endGang: "目的港",
  English: "英文",
  enter: "请输入",
  entry_fee: "录入费",
  entryNo: "入仓号",
  equipment: "设备名称",
  error: "失败",
  error_mes: "错误信息",
  error_value: "可接受误差范围",
  Evidence_file: "举证文件",
  excel_path: "excel链接",
  exception_code: "异常代码",
  exception_msg: "异常描述",
  exception_status: "异常状态",
  exception_time: "异常时间",
  exception_type: "异常类型",
  exceptionNum: "异常次数",
  exceptionTracker: "轨迹异常规则",
  Excess: "超额",
  ExitExceptionRemark: "退出异常备注",
  exlType: "状态",
  expand: "展开",
  expected_date: "预计到港时间",
  expense: "科目费用",
  expense_item: "收款项目",
  expenseCode: "费用代码",
  expenseName: "费用名称",
  Expired: "过期",
  export: "导出",
  export_tips_msg: "数据暂未生成，稍后重试",
  express_currency: "运费货币",
  express_fee: "快递费",
  expStatus: "导出状态",
  expTime: "导出时间",
  expType: "计费类型",
  extra_charge: "操作费",
  extraCost: "额外费用",
  extract: "提单",
  extract_nums: "提单数量",
  extractList: "提单列表",
  extractNew: "新建提单",
  f_agent_claim: "向责任方索赔",
  fabAccount: "账户",
  fail: "请输入相关信息 ！！！",
  fangdan: "付款方式",
  fbaList: "FBA列表",
  fee_type: "费用类型",
  feedbackArea: "界定区",
  feedbackNum: "反馈号",
  FeedbackPerson: "反馈人",
  feeTerms: "运费条款",
  ferryCode: "船公司代码",
  ferryName: "船公司名称",
  fifth_140: "五派时间",
  fifth_140_time: "五派天数",
  fifth_delivery_remarks: "五派结果",
  fifth_refuse_time: "五派拒签时间",
  file_fee: "文件费",
  fileAgent: "文件代理",
  fileCnb: "单号文件",
  fileName: "文件名称",
  files: "文件",
  finalCost: "成本",
  finance: "财务管理",
  finance_amount: "财务实付金额",
  finance_currency: "财务实付币种",
  financeEmail: "财务邮箱",
  finances: "财务",
  financialZoning: "财务分区",
  finish: "完结",
  finish_time: "全程签收天数",
  finished: "已完结",
  finishTime: "完结时间",
  first_140: "首派时间",
  first_140_time: "首派天数",
  first_delivery_remarks: "首派结果",
  first_party: "首派",
  first_refuse_time: "首派拒签时间",
  firstWeight: "首重重量",
  firstWeightFreight: "首重运费",
  fixed: "固定",
  fixed_fee: "固定计费",
  flight: "航班",
  flight_time: "航运",
  flow: "财务流水",
  flow_num: "流水单号",
  follow: "跟进",
  follow_up_customer_service: "总部跟进客服",
  FollowArea: "跟进区",
  FollowCase: "跟进情况",
  FollowPerson: "跟进人",
  followRecord: "跟进记录",
  FollowTime: "跟进时间",
  forecastManagement: "预报管理",
  form_data: "请完善表单数据",
  FormalClearance: "正常清关",
  four_hours: "72小时后",
  fourth_140: "四派时间",
  fourth_140_time: "四派天数",
  fourth_delivery_remarks: "四派结果",
  fourth_refuse_time: "四派拒签时间",
  freeze_quantity: "正在拣货",
  freight: "小包运费规则",
  freight_append: "附加费",
  freight_fees: "运费",
  freight_unit: "应收币种",
  freightName: "运费标题",
  freightrule: "参数",
  from_channel: "原始渠道",
  from_city: "起运城市",
  from_country: "起运国家",
  from_station: "起运地",
  FrontIDCard: "身份证正面",
  fuel_fee: "燃油费",
  fullName: "全称",
  gather: "总",
  generate_bank_fee: "生成银行手续费账单",
  generate_claim_bill: "生成理赔账单",
  generateBill: "生成库位账单",
  generateBills: "已经生成的账单",
  go_to_review: "进入复审",
  goods: "商品存储",
  goods_nature: "货物性质",
  goodsSku: "商品信息",
  group_name: "分组名称",
  group_name1: "群聊名称",
  growthRate: "增长率",
  half_moon: "半月",
  handle: "处理",
  handleFee: "COD手续费规则",
  handler: "处理人",
  handling_opinions: "处理意见",
  HandlingFee: "手续费",
  hang: "挂起",
  has_electric: "带不带电",
  has_paper: "是否有纸质",
  has_tableware: "是否带餐具标识",
  has_trademark: "有无牌子",
  have: "有",
  hedge_amount: "集运对冲额度",
  hedge_t: "对冲",
  hedging: "对冲",
  height: "高",
  Helian: "合联",
  hide: "隐藏",
  high: "旺季附加费",
  highest: "最高",
  HKagency: "中港代理",
  home: "首页",
  homeAbnormal: "国内仓异常件",
  hongkong: "香港",
  hongkong_pickup_fee: "香港提货费",
  hq: "总部",
  hsCode: "海关编码",
  hub: "是否中转",
  hw_bill_branch: "海外账单(分公司)",
  hw_shipment_branch: "海外出货明细(分公司)",
  hwBill: "海外账单",
  hwShipment: "海外出货明细",
  ignore_error: "忽略错误",
  img: "图片",
  immediately: "立即",
  import: "导入",
  inactive: "不活跃",
  inbound: "入库",
  inbound_time: "入仓时间",
  inboundFordeal: "Fordeal头程入库",
  firstOrder: "头程订单列表",
  inboundManifest: "入库单",
  inboundStatus: "入库完成",
  inboundTime: "入库时间",
  income: "收入",
  IncomingInspection: "入库检测",
  indexes: "索引",
  info: "信息提示",
  information: "信息",
  INSIDE_PARCEL: "合包子包裹",
  inspectionPhoto: "验货照片",
  instruction: "备注指令",
  instructionFile: "指令文件",
  insurance_fee: "保险费",
  internal: "内部用户",
  interval: "区间",
  Inventory: "上架库存",
  invoice: "发票",
  invoice_header: "发票抬头",
  invoice_number: "发票号码",
  invoiceDescription: "Sku码",
  invoiceHSCod: "海关编码",
  invoiceInsValue: "价值",
  invoiceName: "名称",
  invoicePCS: "件数",
  invoiceWeight: "重量",
  ip: "IP地址",
  is_board: "是否板货",
  is_calculate: "是否公式计算",
  is_def: "是否默认",
  is_goods: "货物",
  is_hedge: "是否集运对冲",
  is_invoicing: "是否开发票",
  is_oversea: "是否海外仓",
  is_paid: "已支付",
  is_pod: "是否POD",
  is_publish: "是否对外公布",
  is_solely: "单独报关",
  is_unique: "是否唯一",
  isAdditionalCharges: "是否有额外费用",
  isOrder: "已出单",
  isPaper: "是否含有纸质版",
  isUnpack: "是否拆包",
  items: "条",
  job: "岗位",
  job_number: "工号",
  jump: "跳转",
  keyword: "关键字",
  keywords_type: "关键字类型",
  kongFee: "空运费",
  label: "标签",
  label_url: "面单链接",
  labelName: "规则名称",
  landingTime: "到达时间",
  language: "语言",
  last_customer_nums: "上月客户数",
  last_month: "上月",
  last_order_nums: "上月订单量",
  last_order_pods: "上月COD签收量",
  lastCallTime: "最后呼叫时间",
  lastMonth: "上月",
  latest_delivery_remarks: "最新结果",
  latest_delivery_time: "最新派送时间",
  launch: "发起",
  length: "长",
  level: "一级",
  Level_child: "子级",
  Level_one: "一级",
  Level_two: "二级",
  LibraryDay: "每日出库",
  LinkedData: "关联数据",
  liquidPCS: "带液体件数",
  list: "列表",
  ListData: "列表数据",
  load_type: "清关文件",
  localFaction: "地派",
  location: "所在库位",
  location_bill: "库位账单",
  location_t: "库位",
  login: "登录",
  lost_ticket_nums: "丢件",
  lowCost: "低消",
  lower_threshold: "最小重量",
  lowest: "最低",
  magnetic: "带磁",
  mail_note: "邮寄备注",
  mainland: "大陆",
  MaintainExchangeRate: "维护汇率",
  maitou: "唛头",
  manager_remarks: "管理员备注",
  manifest: "manifest",
  mapping: "异常映射",
  mapping1: "映射",
  mapping_rule: "映射规则",
  mappingChannel: "映射渠道",
  markField: "唛头栏位",
  match_city: "城市分组",
  match_client: "用户分组",
  match_cod_amount: "判断代收金额",
  match_cod_operator: "代收金额操作符",
  match_service_type: "匹配服务",
  match_values_amount: "货物价值金额",
  match_values_operator: "货物价值操作符",
  material_fee: "物料费",
  mawb: "提单号",
  max_weight: "续重",
  maxCall: "最多拨打次数",
  menuName: "菜单名称",
  menuRouting: "菜单路由",
  message: "消息",
  messageList: "消息列表",
  method: "运输渠道",
  method_code: "运输代码",
  method_name: "运输方式",
  methodTransfer: "转账方式",
  middleGang: "中转港",
  min_weight: "首重",
  mini: "迷你",
  mobiledevice: "手持设备",
  mode: "方式",
  model: "型号",
  modify: "修改",
  month: "月份",
  month_t: "月",
  monthly_fee: "月度费用",
  monthly_shipment: "月发货量",
  move: "运",
  MoveIn: "移入",
  moveOperation: "更多操作",
  MoveOrder: "移入该订单",
  MoveOut: "移出",
  multiple_details: "多个明细逗号分隔",
  multiProduct: "多品",
  n_process: "未处理",
  need: "需要",
  unNeed: "不需要",
  needAssistPerson: "提醒人",
  NetworkError: "网络异常",
  new_tracker_code: "最新轨迹代码",
  new_tracker_time: "最新轨迹时间",
  newAirWaybill: "新建空运提单",
  newB2bPacking: "新建B2B中港单",
  newest: "最新",
  newPacking: "新建中港单",
  newSeaWaybill: "新建海运提单",
  newSecond: "新建二级",
  newSouq: "新建SouQ",
  NO: "否",
  no_plan: "未上传解决方案",
  noofpieces: "数量",
  noon: "NOON",
  noOrder: "未出单",
  noPass: "不通过",
  noResponse: "无响应",
  normal: "正常",
  Not: "未",
  not_arrival_warehouse: "未到仓数",
  not_bound: "未绑定",
  not_excel_tip: "不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。",
  not_listed_number: "未上架库存",
  not_stock: "未出库",
  not_through: "不通过",
  not_update_time: "无更新天数",
  nothing: "无",
  notPick: "未取件",
  NotWrittenOff: "未核销",
  now: "现在",
  nowCallNum: "当前呼叫次数",
  num_lengths: "号码长度",
  number: "数值",
  number_of_bags: "件数",
  number_of_shipment: "总票数",
  numMax: "最大",
  numMin: "最小",
  numPeople: "人数",
  Odd_Numbers: "单号",
  old: "旧",
  oms: "内部端",
  on_shelve: "是否上架",
  one_class: "一级分类",
  one_hours: "24小时内",
  onlineTime: "上架时间",
  onTheWayTicket: "在途票数",
  open: "公布",
  operate: "操作人",
  operate1: "操作人",
  operation: "操作",
  operationLog: "操作记录",
  operationModules: "运营模块",
  operWarehouse: "操作仓库",
  order: "订单模块",
  order_address: "收件人地址",
  order_address1: "备用地址",
  order_desc: "备注",
  order_detected: "是否检测",
  order_goods: "商品数量",
  order_goods1: "商品数量",
  order_number: "订单号码",
  order_nums: "本月订单量",
  order_pcs: "包裹数量",
  order_pcs1: "包裹数量",
  order_phone: "收件人电话",
  order_phone1: "收件备用电话",
  order_pods: "本月COD签收量",
  order_price: "代收金额",
  order_rate: "跟进订单增加量",
  order_recivre: "收件人",
  order_refCode: "代理单号",
  order_reset: "重置",
  order_save: "保存到草稿",
  order_submit: "提交",
  order_t: "订单",
  order_type: "支付方式",
  order_type1: "支付方式",
  order_type_t: "订单类型",
  order_userRef: "客户单号",
  orderBlock: "拦截",
  orderBlockRate: "拦截率",
  orderConfirm: "已确认订单",
  orderDestroy: "销毁订单",
  orderError: "异常订单",
  orderErrorN: "异常订单(新)",
  orderIn: "入库订单",
  orderInfo: "订单信息",
  orderIsUnique: "是否唯一",
  orderList: "全部订单",
  orderNum: "订单号",
  orderNums: "订单数量",
  orderQuantity: "订单下单的箱数",
  orderOutboundQuantity: "出货箱数",
  orderOut: "出库订单",
  orderReturn: "退回订单",
  orderRtc: "在仓退回",
  orderRtw: "退回海外仓",
  orderservice: "收款类型",
  orderStatusList: "签收率",
  orderTransferred: "已转订单",
  orderType: "当前订单状态",
  orderWait: "未确认订单",
  ordinary: "普通",
  ori_pack: "原包库存",
  ori_pack_cnb: "原包cnb单号",
  original: "原始",
  original_packing_num: "原单箱号",
  original_shelves: "原包上架",
  originalCodAmount: "原COD合计金额",
  OriginalCurrency: "原始币种",
  orther: "其他",
  otherCost: "其他费用",
  out: "出库",
  out_number: "实际出货",
  whole: "完全",
  outbound: "出库",
  outbound_quantity: "出库记录",
  outbound_time: "出库时间",
  Outboundrecord: "出库记录",
  outboundTime: "出库时间",
  outerBoxNumber: "外箱单号",
  outNumber: "实际出货数量",
  OutOrderNum: "出库单号",
  outTicket: "出派",
  outTicket_rate: "出派率",
  outTimeday: "超时天数",
  overload_fee: "超件费",
  overseas: "海外仓",
  Overseasdistribution: "海外配货",
  overseasNumber: "马帮订单编号",
  overseasOrderList: "马帮订单列表",
  overseasWarehouse: "马帮海外仓",
  overtime: "超时",
  overtime_fee: "加班费",
  overtime_order: "超时订单",
  overweight_fee: "超重费",
  ownerCountry: "所属国家",
  ownership: "所属公司",
  package: "代理包裹",
  package1: "合包",
  PACKAGE_CONCLUDED: "合包",
  package_number: "包裹号码",
  packageOrder: "合包操作",
  packageTitle: "显示渠道",
  packageType: "包裹类型",
  packet: "小包",
  packetReport: "小包报表",
  packing: "中港单",
  packing_freight: "中港运费",
  packing_number: "中港单号",
  packingData: "中港单数据",
  packingList: "中港单列表",
  packingNum: "箱号",
  packingNumber: "中港单数",
  page: "本页",
  pageButton: "页面按钮",
  pageName: "页面名称",
  paid: "付款金额",
  paid_for: "已收款",
  paid_time: "打款时间",
  paper_fee: "关税资料费",
  paramsAccount: "参数账号",
  paramsAgent: "归宿代理",
  paramsPwd: "参数密码",
  paramsSet: "参数密钥",
  paramsType: "参数类型",
  paramsUrl: "参数地址",
  parking_fee: "停车费",
  partitionCode: "分区代码",
  partitionName: "分区名称",
  paServicePerformance: "小包客服绩效",
  pass: "通过",
  pass_nums: "达标数量",
  pass_rate: "达标率",
  password: "登录密码",
  pathIcon: "图标",
  pathName: "中文名",
  pathUrl: "路径",
  pay: "支付",
  pay_way: "渠道来源",
  payable_amount: "应付金额",
  payable_cost_total: "应付成本合计",
  payable_currency: "应付币种",
  payable_expenses: "应付费用",
  payBalance: "扣款",
  payment: "支付模式",
  payment_account: "账户名",
  payment_description: "描述",
  payment_freight: "支付运费",
  payment_title: "支付说明",
  paymentCode: "付款码",
  paymentType: "付款类型",
  peak_fee: "旺季附加费",
  Pending: "待处理",
  per_ticket: "每票",
  performance: "绩效管理",
  period: "结账周期",
  personal_cn: "个人中文名",
  personal_en: "个人英文名",
  personnel: "人员",
  phone: "手机号码",
  phoneError: "电话错误",
  phoneErrorRate: "电话错误率",
  PhoneNotResponding: "电话无响应",
  PhoneNotRespondingRate: "电话无响应率",
  pick: "取件",
  picked: "已拣货数量",
  picker: "提货派送商",
  pickImage: "揽件图片",
  Picking: "拣货中",
  pickingStatus: "拣货状态",
  pickList: "拣货单列表",
  pickupNumber: "拣货单号码",
  placeOrder: "下单",
  plan: "解决方案",
  plan1: "解决方案",
  plan_location: "所在地",
  plan_remark: "退件描述",
  plan_t: "方案",
  planName: "方案名称",
  planReturn: "退回",
  planStatus: "处理结果",
  planSub: "提交方案上架",
  pod: "签收",
  pod_num: "签收数",
  pod_rate: "签收率",
  pod_type_txt: "pod类型",
  PodAlready: "已POD",
  podError: "POD异常列表",
  popup: "弹窗",
  port: "港口管理",
  portal: "客户端",
  portCode: "港口代码",
  portName: "港口名称",
  positive: "正向",
  postal_usage_fee: "邮政使用费",
  preferential: "优选抬头",
  prefix: "袋子前缀",
  Prepaid: "预付件",
  prepaid_fee: "代垫费用",
  Press: "按",
  pretendNumber: "装箱数",
  preview: "预览",
  price_t: "价格",
  print: "打印",
  process_status: "处理状态",
  processing_time: "处理时间",
  ProcessingProgress: "处理进度",
  productName: "品名",
  profit: "利润",
  profit_rate: "利润率",
  prospecting_fee: "地勘费",
  province: "省",
  proxyException: "代理异常",
  proxyPush: "代理推送",
  public: "公共",
  publicAuth: "公共权限",
  publish: "发布",
  publisher: "发布人",
  push: "推送",
  pushClinet: "推送客户",
  pushed_time: "推送时间",
  pushProxy: "推送代理",
  qq: "QQ",
  quantity: "库位数量",
  quantity_analysis: "当前分析中的数量",
  quantity_num: "个数",
  querySearch: "查询",
  midMonthData: "月中数据",
  rate: "汇率",
  rateDiff: "汇率差",
  ratio: "比例",
  re_enter: "请不要重复输入！",
  re_start: "重新发起",
  Read: "已读",
  read_error: "读取异常",
  read_time: "阅读时间",
  read_to_confirmed: "已确定阅读",
  ready: "准备",
  realname: "姓名",
  rearEnd: "后端",
  reason: "原因",
  reason_billing: "计费原因",
  ReasonFeedback: "反馈原因",
  RebatesRefundsDiscounts: "返佣/折扣",
  ReceiptRate: "签收率",
  receiptTicket: "已签收票数",
  receiptTime: "海外仓签收时间",
  receivable: "应收",
  receivable_expenses: "应收费用",
  receivableReport: "COD应收报表",
  ReceivableSummary: "应收汇总表",
  received_agent_claim: "已收到责任方理赔款",
  received_agent_claim_date: "责任方理赔款收到日期",
  received_company: "收款单位",
  reChAmount: "金额",
  recharge: "充值",
  recipientInfo: "收件人信息",
  record: "记录",
  Redistribute: "重新配送",
  refund: "退款",
  refundAmount: "应退金额",
  refunded: "已退款",
  refundHandlingFee: "应退手续费汇总",
  refundReport: "COD应退报表",
  refundSummary: "应退汇总表",
  refundtotal: "总应退",
  refusal_number: "拒签次数",
  refusal_rate: "拒签率",
  refuse: "拒绝",
  refuse_number: "拒签次数",
  refuse_rate: "拒收率",
  refuse_t: "拒签",
  refuse_t_rate: "拒签率",
  reject: "驳回",
  reject_client: "驳回客户",
  reject_prel: "驳回初审",
  related: "相关",
  RELATED_CNBS: "关联票数",
  RELATED_CTNS: "关联件数",
  relatedMe: "与我相关",
  relatedOther: "关联其他",
  relatedPersonnel: "关联人员",
  relation: "关联",
  Remaining_available: "剩余可处理",
  REMARK: "客服备注指令",
  remarkPlaceholder: "理赔金额的计算规则，金额的由来，等详细情况",
  Remarks: "备注",
  remote_fee: "偏远费",
  remote_regions: "是否偏远地区",
  remote_regions_fee: "偏远附加费",
  RemoveOrder: "移出该订单",
  reOrder: "重新下单",
  replace_currency: "代收币种",
  report: "报表",
  report_location: "库位明细",
  report_time: "上报时间",
  request_time: "拦截时间",
  resAmount: "重新计算",
  reserve: "保留",
  reserve1: "预约",
  residence_time: "在港",
  Responsibility_party: "责任方",
  responsible_claim: "责任方理赔",
  reStatistics: "重新统计",
  result: "结果",
  result_see: "请前往结果列表查看",
  retired_times: "出派次数",
  return: "回传",
  return1: "退件",
  return_t: "返回",
  returnException: "退货取件异常",
  returnOrder: "退件列表",
  returnPick: "退货取件",
  returnRefund: "退货退款",
  reverse: "反向",
  ReverseIDCard: "身份证反面",
  reviseProcessStatus: "修改处理状态",
  riskControl: "额度风控",
  role: "角色管理",
  role_map: "角色映射",
  role_t: "角色",
  roleAuth: "角色权限",
  roleName: "角色名称",
  roleSort: "角色权限",
  routeCode: "航线代码",
  routeName: "航线名称",
  routingAddress: "路由地址",
  rule_sel_tips: "最多只能选中一个客户",
  rule_supplier: "提供者",
  s_package_report: "小包汇总报表",
  salesman: "销售名称",
  salesman_remarks: "业务备注",
  sea: "船公司管理",
  sea_freight: "海运运费",
  sea_transport: "海运",
  seaIncome: "海运收入录入",
  seal: "封条",
  search: "搜索",
  seaWaybillList: "海运提单列表",
  second_140: "二派时间",
  second_140_time: "二派天数",
  second_delivery_remarks: "二派结果",
  second_refuse_time: "二派拒签时间",
  security_fee: "安检费",
  selDocument: "选中文件",
  select: "请选择",
  selected: "选中",
  selectPrint: "选择打印",
  self_mention: "自提",
  sell: "售卖",
  send: "发送",
  DELIVERY_TIP: "请确认不修改信息继续派送",
  TO_WMS_TIP: "是否执行转海外仓操作",
  PICKUP_TIP: "是否执行继续取件操作",
  send_express: "寄快递",
  send_price: "送货上门费用",
  Sender: "发件人",
  separateDeclaration: "单独报关",
  serial_number: "序号",
  serialNumber: "序号",
  service: "客服",
  SERVICE_ITEM: "交付商",
  serviceAccount: "客服名称",
  serviceName: "小包客服",
  serviceProcessed: "待客服处理",
  serviceType: "服务类型",
  SetOriginalCurrency: "结算原始币种",
  setting: "设置",
  seven_pod_rate: "7天签收率",
  share_type_txt: "分摊类型",
  sheet: "面单",
  shipAgent: "船务代理",
  shipCost: "费用信息",
  shipInfo: "订舱信息",
  shipDocument: "做箱计划",
  seaShipperName: "托运人",
  shipment: "小包出货明细",
  createSeaUser: "制单人",
  shipInvoices: "报关单据",
  shipment_all: "发货量",
  shipment_place: "出货地",
  shipmentBatch: "出货批次",
  shipmentBranch: "小包出货明细(分公司)",
  shipmentNumber: "出货数量",
  SHIPMENTS: "票数",
  shipmentTicket: "出货票数",
  shipmentTime: "子批次出货时间",
  shipmentvolume_seven_days: "近7日发货量",
  shipmentWeight: "出货重量",
  shipper_company: "Vnlin ID/集运ID",
  shipper_company_cn: "公司中文名",
  shipper_company_en: "公司英文名",
  shipper_mobile: "联系人号码",
  shipper_telephone: "卖家售后联系号码",
  shipperAddress: "寄件地址(英文)",
  shipperCode: "寄件公司ID",
  shipperName: "寄件人姓名",
  shipperRef: "原单号",
  shipperRef1: "原单号",
  shipping_agent: "海运代理",
  shipping_company: "船公司",
  shipping_mode: "出货模式",
  ShippingDate: "出货日期",
  shippingInfo: "运件信息",
  shippingTerms: "运输条款",
  shop_name: "店铺名称",
  shopName: "店铺名称",
  should_delivery_time: "应派时间",
  shouldCallNum: "应当呼叫次数",
  show: "查看",
  show1: "显示",
  Shuangqing: "B2B",
  signDownload: "签收单下载",
  SignedAmount: "签收量",
  singleBox: "单箱数量",
  singleProduct: "单品",
  site_name: "站点名称",
  size: "尺寸",
  sku: "商品信息",
  skuAlias: "伪装商品名称",
  skuAmount: "申报金额",
  skuCode: "客户编码",
  skuHeight: "高度",
  skuInfo: "货物详情",
  skuLength: "长度",
  skuName: "商品名称",
  skuName1: "商品名称",
  skuTitle: "商品英文名称",
  skuTitle1: "商品英文名称",
  skuVolume: "体积",
  Volume: " 体积",
  skuWeight: "商品重量",
  skuWeight1: "商品重量",
  skuWidth: "宽度",
  sll_weight: "最小重量",
  small_package_audit: "小包审核",
  sms: "短信模板",
  sms_warning: "警告",
  sort: "排序值",
  souq: "SouQ订单",
  souqNum: "SouQ单号",
  source: "来源",
  spare_contract_header: "备选合同抬头",
  spc_way_weight: "特殊计费重",
  special: "特殊",
  special_remark: "特殊备注",
  specialRule: "特殊规则",
  specialSign: "特殊签收单",
  specific: "具体",
  sponsor: "发起人",
  square: "方数",
  standard: "标准",
  standard_role: "映射角色",
  start: "开始",
  startGang: "起运港",
  startingTime: "开始时间",
  startStatist: "开始统计",
  startToend: "合同起始日期",
  statistics: "统计",
  status: "是否可用",
  status_cn: "中文轨迹描述",
  status_flag: "录入标识",
  status_hidden: "是否隐藏",
  status_location: "轨迹地点",
  status_operator: "操作者",
  status_time: "轨迹更新时间",
  status_time1: "轨迹更新时间",
  status_timezone: "轨迹时区",
  stayDone: "待完成",
  step_price: "续重费用",
  sticker_fee: "贴面单贴标费",
  stock: "商品库存",
  storage: "仓储管理",
  storage_quantity: "本月最大存放数量",
  storageFee: "仓储费用明细",
  store_name: "商家名称",
  subcontract: "分包",
  subcontractForecastList: "分包预报列表",
  submitUser: "提交人",
  subPackage: "子包裹",
  subPackage1: "分包",
  subplan: "提交方案",
  success: "成功",
  summary: "汇总",
  summary_ship_details: "成本汇总明细",
  summaryBill: "账单汇总",
  supplier: "供应商",
  switchChannel: "切换渠道",
  synchronous: "同步数据",
  sys: "系统",
  sysLabel: "绘制规则",
  system: "设置管理",
  system_shelf: "系统上架",
  systemSub: "系统上架",
  takeOffTime: "起飞时间",
  target_airport: "起运地",
  target_channel: "切换渠道",
  target_country: "目的国家",
  task_no: "汇总账单号",
  tax: "税金",
  tax_currency: "关税货币",
  tax_fee: "关税",
  taxCurrency: "税费货币",
  taxFee: "税费",
  telephone: "联系电话",
  template: "模板",
  template_content: "模板内容",
  template_name: "模板名称",
  ten_pod_rate: "10天签收率",
  the_smaller_value: "值越小排序越前",
  Thetwopasswords: "两次密码不一致",
  third_140: "三派时间",
  third_140_time: "三派天数",
  third_delivery_remarks: "三派结果",
  third_refuse_time: "三派拒签时间",
  this_month: "本月",
  thisMonth: "本月",
  three_hours: "48-72小时",
  three_party: "三派",
  three_pod_rate: "3天签收率",
  threshold: "关税门槛",
  threshold1: "门槛",
  through: "通过",
  time: "时间",
  time_in_transit: "在途天数",
  time_in: "在途",
  time_in_rate: "在途率",
  time_not_31day: "时间不能超过31天",
  timelyDelivery: "及时派送",
  timeoutUnsent: "超时未派",
  timesAnalysis: "报表中心",
  timesList: "时效列表",
  timeType: "时间类型",
  timezone: "时区管理",
  timezoneFormat: "时区格式",
  timezoneName: "时区名称",
  tip: "状态",
  tip1: "提示信息",
  titleModal: "是否执行此操作 ?",
  to: "转换",
  to_rmb: "人民币",
  to_station: "目的地",
  to_usd: "美元",
  to_aed: "迪拉姆",
  toCurrency: "目标货币",
  toggle: "切换",
  toHKtime: "到港时间",
  ToPay: "到付件",
  total: "合计",
  total_amount: "总金额",
  total_fee: "总手续费",
  Total_original_currency: "总原币金额",
  total_out_ticket_nums: "总出货票数",
  TOTAL_PARCEL: "总订单票数",
  total_tax: "总税额",
  total_votes: "总票数",
  total_votes1: "总票数",
  totalAeclaredAmount: "总申报价值",
  totalArrears: "总欠款",
  totalNoofpieces: "总箱数",
  totalNumber: "总数量",
  TotalReceivable: "总应收",
  totalWeight: "包裹重量",
  trace: "代理轨迹映射",
  track_title: "轨迹描述",
  tracker: "运输管理",
  tracker_code: "轨迹代码",
  tracker_description: "最新轨迹描述",
  tracker_description_cn: "中文描述",
  trackerCities: "城市分组",
  trackerClients: "客户分组",
  trackererror: "轨迹映射错误列表",
  trackerparams: "代理参数",
  trackerStatus: "轨迹管理",
  trackerSwitch: "规则切换",
  tracking_number: "快递单号",
  trackingNumber: "货件追踪编号",
  trackRecord: "录轨迹",
  trademark: "商标",
  trajectory: "轨迹",
  transaction_id: "银行交易流水",
  transfer_num: "转单号",
  transfer_order: "转单",
  transferList: "转单拣货单列表",
  TransferOrder: "转单",
  transport_method: "运输方式",
  transport_mode: "运输渠道",
  transportCost: "运输费用",
  TravelStatus: "行程状态",
  tuoyunUser: "托运跟单员",
  turn: "转",
  turn_to: "转到",
  two_hours: "24-48小时",
  two_party: "二派",
  type: "类型",
  unapod: "未签收",
  Unbilled: "未出账单",
  unbind: "解绑",
  unConfirm: "未确认重量",
  UngeneratedBills: "未生成的账单",
  unInventory: "未上架库存",
  unit: "单位管理",
  unit_t: "单位",
  unitName: "单位名称",
  unpack: "拆包",
  unpack_sheves: "拆包上架",
  unpackEnquiry: "拆包查询",
  unpaid: "未支付",
  unperfect: "未完善",
  Unread: "未读",
  UnrefundedAmount: "未退金额",
  up: "上架",
  update: "更新",
  updateFile: "上传",
  updateLog: "修改记录",
  updatePwd: "更新密码",
  newPwd: "新密码",
  changePWd: "修改密码",
  updateTrace: "批量更新轨迹",
  upload: "请上传",
  uploaded: "已上传文件",
  uploadLocationInfo: "上传库位修改信息",
  uploadRes: "上传结果",
  uploadTe: "(如购买发票，证明产品价值)",
  uploadText: "点击或拖动文件或图片上传",
  upper_threshold: "最大重量",
  upTime: "更新时间",
  use_quantity: "可用库存",
  Useless: "没有",
  user: "用户管理",
  user_name: "用户名",
  userName: "登录账号",
  userPwd: "登录密码",
  value: "值",
  values: "货物价值",
  valueService: "增值服务",
  valueServiceInfo: "增值服务信息",
  VAT_charges: "VAT费率",
  vat_fee: "消费税",
  vat_rate: "VAT税率",
  VATFee: "VAT费",
  verify_status: "审核状态",
  virtual_airway_number: "虚拟单号",
  virtualWarehouse: "虚拟仓操作",
  virtualWH: "虚拟仓",
  vnlinTrackCode: "合联轨迹代码",
  Votes: "票数",
  wait: "待",
  modifyCodRecords: "修改cod记录",
  Wait_Picking: "待拣货",
  waitError: "异常待处理",
  warehousCustomsAgent: "进仓报关代理",
  warehouse: "仓库",
  warehouse_fee: "仓储费",
  warehouse_in_out: "出入仓",
  warehouse_name: "发货仓",
  warehouse_return_rate: "回仓率",
  warehouse_status: "异常类型",
  warehouse_t: "仓库",
  warehouse_time: "到目的仓时间",
  warehouseAddress: "仓库地址",
  warehouseAddress1: "海外仓收货地址",
  warehouseCity: "仓库城市",
  warehouseCode: "仓库代码",
  warehouseID: "仓库ID",
  warehouseManagement: "仓库管理",
  warehouseName: "仓库名称",
  warehouseName1: "仓库名称",
  warehouseName2: "仓库名称",
  warehousePhone: "海外仓收货电话",
  waybillNumber: "运单号",
  WaybillPickingStatus: "运单拣货状态",
  wechat: "微信",
  week: "周",
  Weight: "重量",
  weights: "权重",
  whether: "是否",
  include: "包含",
  whitelist: "白名单",
  width: "宽",
  wight: "总重量",
  withdraw: "撤回",
  writeOff: "核销",
  WrittenOff: "已核销",
  wrong: "错误",
  y_process: "已处理",
  YES: "是",
  yesterday: "昨天",
  zaji_mapping: "代理城市映射",
  Zh: "(中文)",
  zhTitle: "标题",
  zip_code: "邮政编号",
  show: "显示",
  showDetail: "查看",
  batch: "批量",
  Thetwopasswords: "两次密码不一致",
  re_enter: "请不要重复输入！",
  form_data: "请完善表单数据",
  through: "通过",
  not_through: "不通过",
  normal: "正常",
  wait: "待",
  bankDetails: "银行详细信息",
  china: "中国",
  mainland: "大陆",
  hongkong: "香港",
  half_moon: "半月",
  week: "周",
  day: "天",
  month_t: "月",
  active: "活跃",
  inactive: "不活跃",
  correspond: "对应",
  go_to_review: "进入复审",
  label: "标签",
  ordinary: "普通",
  special: "特殊",
  not_bound: "未绑定",
  accept: "接受",
  level: "一级",
  child: "子级",
  fixed: "固定",
  interval: "区间",
  lowest: "最低",
  highest: "最高",
  charge: "收费",
  chargeType: "收费类型",
  reserve: "保留",
  now: "现在",
  hide: "隐藏",
  bag: "袋子",
  job: "岗位",
  hq: "总部",
  img: "图片",
  NoData: "暂无数据",
  charged_details: "带电明细",
  multiple_details: "多个明细逗号分隔",
  the_smaller_value: "值越小排序越前",
  wrong: "错误",
  read_error: "读取异常",
  not_excel_tip: "不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。",
  time_not_31day: "时间不能超过31天",
  tip1: "提示信息",
  turn_to: "转到",
  costing: "财务成本",
  Level_two: "二级",
  cycle: "周期",
  last_month: "上月",
  this_month: "本月",
  Remaining_available: "剩余可处理",
  public: "公共",
  immediately: "立即",
  items: "条",
  cross_port: "过港",
  delivery: "派送",
  city_t: "城市",
  collection_t: "代收",
  taxCurrency: "税费货币",
  RebatesRefundsDiscounts: "返佣/退款/折扣折让",
  cope: "应付",
  profit: "利润",
  profit_rate: "利润率",
  reserve1: "预约",
  reserve1_rate: "预约率",
  overtime_order: "超时订单",
  three_party: "三派",
  originalCodAmount: "原COD合计金额",
  two_party: "二派",
  first_party: "首派",
  return1: "退件",
  yesterday: "昨天",
  auto_acquire: "自动获取",
  read_to_confirmed: "已确定阅读",
  claim_t: "申明",
  on_shelve: "是否上架",
  editLocationInfo: "修改库位数据",
  uploadLocationInfo: "上传库位修改信息",
  downloadLocationInfo: "下载库位修改模板",
  BankTransfer: "银行转账",
  methodTransfer: "转账方式",
  cash: "现金",
  hedge_t: "对冲",
  remote_fee: "偏远费",
  overweight_fee: "超重费",
  overload_fee: "超件费",
  material_fee: "物料费",
  on_shelve: "是否上架",
  shipment_hq: "小包出货明细(总部)",
  cost_bill: "成本账单",
  createBill: "创建账单",
  extractType: "提单类型",
  classExpense: "科目费用",
  BillingNumber: "计费单号",
  bank_name: "付款银行",
  pay_time: "打款时间",
  pay_picture: "付款凭证",
  select_fee_detail: "请选择费用明细",
  UsdToRMB: "美金转人民币汇率",
  SarToRMB: "沙特币转人民币汇率",
  HkdToRMB: "港币转人民币汇率",
  accounting_amount: "核算金额",
  refunded: "已退款",
  paid_for: "已收款",
  zip_code: "邮政编号",
  CollectionUser: "收款对象",
  writeOffDetail: "核销记录",
  createCostBill: "创建成本账单",
  refund_address: "COD回款地",
  ShipmentDetails: "出货明细",
  HQClient: "总部客户",
  file30M: "文件不能超过30M",
  summary_ship_details_new: "成本汇总明细(新)",
  pod_time: "签收时间",
  pod_time1: "签收时间",
  bill_hq: "小包账单(总部)",
  AmountHedged: "已对冲金额",
  transportation: "运输",
  Required: "必填",
  PickUp: "上门提货",
  Contacts: "联系人",
  deliverGoods: "送货",
  numberPlate: "车牌号",
  address: "地址",
  PickAtDoor: "上门自提",
  SelfDelivery: "自送（叫车自送）",
  ExpressLogistics: "快递/物流送合联仓",
  ExpressLogisticsName: "快递/物流名称",
  ExpressLogisticsNumber: "快递/物流单号",
  changeOrder: "换单",
  preparing: "准备中",
  PackingSlip: "装箱单",
  ListOverseasWarehouses: "海外仓上架随货清单",
  DoorServicePackingList: "门到门服务装箱单",
  msg_401: "您没有浏览这个页面的权限",
  msg_404: "您的页面好像飞走了",
  msg_500: "鬼知道服务器经历了什么",
  NoData: "暂无数据",
  ClaimsLetter: "索赔函",
  Collection_t: "代收",
  city_t: "城市",
  RemoteRegions: "偏远地区",
  delivery_t: "派送",
  crossPort: "过港",
  objection: "有异议",
  Settled: "已结算",
  MAWB: "提单号",
  two_class: "二级分类",
  picking_t: "拣货",
  onLine: "线上",
  offLine: "线下",
  expenseNameEn: "费用英文名称",
  branch_shipment: "小包出货明细",
  branch_bill: "小包账单",
  TrailerCustomsBroker: "拖车报关代理",
  b2bDetailTip: "当前流入规则：订单模块，B2B订单页面，需有入库标识（✔ ），出库标识（✔ ）以及提交完善信息标识（✔ ）同时存在",
  cod_amount1: "COD金额",
  destination: "目的地",
  reimburseManage: "报销管理",
  reimburseCategory: "报销分类",
  CategoryName: "分类名称",
  reimburseApply: "发起报销",
  inReview: "审核中",
  Passed: "已通过",
  Rejected: "已拒绝",
  detailName: "明细名称",
  detailAmount: "明细金额",
  reimburseDetail: "报销明细",
  approvalAmount: "审批流",
  ApprovalPending: "待审批",
  approval: "报销审批",
  proposer: "申请人",
  ImportCargo: "导入集运",
  costSuject: "成本科目",
  sujectName: "科目名称",
  endTripManage: "尾程管理",
  endTripBill: "尾程提单",
  safetyAgent: "保险代理",
  up_t: "上移",
  down_t: "下移",
  charge_params1: "计费重",
  hw_bill_hq: "海外账单(总部)",
  hw_shipment_hq: "海外出货明细(总部)",
  medium: "中等",
  ox: "1倍",
  tx: "2倍",
  costCategories: "成本大类",
  endTripFee: "尾程费",
  zx: "0倍",
  incomeSubject: "收入科目",
  reimburse: "报销",
  repeal: "撤销",
  alreadyRepeal: "已撤销",
  location_bill_hq: "库位账单(总部)",
  my: "我的",
  platReturnService: "亚马逊NOON退仓服务",
  shopId: "店铺ID",
  returnPlatform: "退货平台",
  trackingCode: "追踪编码",
  ReturnTime: "退货时间",
  ReceiptSign: "签收单",
  ReceiveTime: "接收时间",
  addTime: "添加时间",
  WarehouseNotes: "仓库备注",
  platform: "平台",
  approval_status: "审批状态",
  inReview_my: "待我审核",
  Passed_my: "我已通过",
  Rejected_my: "我已拒绝",
  reimburseSuject: "报销科目",
  personal: "个人",
  airIncomeBill: "空运收入账单",
  USD: "美金",
  HKD: "港币",
  SAR: "沙特币",
  createName: "添加人",
  airIncomeDetail: "空运收入明细",
  to_hkd: "港币",
  to_sar: "沙特币",
  check_remarks: "核销备注",
  to_cny: "人民币",
  comfirmUser: "确认人",
  writeOffUser: "核销人",
  orderNumberInexistence: "以下单号不存在",
  InletTime: "流入时间",
  location_hq: "库位明细(总部)",
  PickUpType: "取件类型",
  HomeDelivery: "送货上门",
  to_qar: "卡塔尔里亚尔",
  to_kwd: "科威特第纳尔",
  b2b_bill_hq: "B2B账单(总部)",
  PortalFinancialModule: "客户端财务模块",
  b2b_details_hq: "B2B出货明细(总部)",
  hongKongPlus: "香港加货",
  join: "加入",
  bubbleType: "分泡方式",
  quantity1: "计费数值",
  sticker: "贴标",
  syncDeliveryFee: "同步派送费",
  ClientCNFullName: "客户中文全称",
  ClientCode: "客户代码",
  firstFee: "头程费用",
  AirOrSeaFreight: "空/海运费",
  endTripFee1: "尾程费用",
  Stevedorage: "装卸费",
  TransferFee: "转运费",
  ReconciliationUserName: "对账人名字",
  PackShipmentNumber: "打包出货件数",
  CNBOrder: "CNB单号",
  referCode: "源单号",
  branch_claim_list: "理赔列表",
  documentsFee: "单证费",
  TrailerOrForkliftFee: "拖/叉车费",
  shipmentAgency: "出货代理",
  createDeliveryBill: "创建派送账单",
  ffc: "FFC",
  ffcShipments: "FFC Shipments",
  returnShipments: "Return Shipments",
  delayShipments: "Delay Shipments",
  deliveryPerformanceSLA: "Delivery performance SLA",
  abnormalShipments: "Abnormal Shipments",
  Append: "追加",
  DelDetail: "删除明细",
  billingCycle: "结算周期",
  extractCost: "提单成本",
  serviceCountry: "服务国家",
  ContactInformation: "联系信息",
  BusinessPhone: "商务联系电话",
  BusinessMail: "商务邮箱",
  ServiceMail: "客服邮箱",
  BranchBank: "银行分行",
  AccountOpeningUsername: "开户人姓名",
  BankCode: "银行代码",
  iban: "大额行号/联行号",
  cod_currency: "结算币种",
  FreightVATRadio: "运费VAT比例",
  b2b_cost: "B2B成本",
  save: "保存",
  safetyService: "保险服务",
  next_page: "续页",
  first_bill: "一级提单",
  secondary_bill: "二级提单",
  lostList: "丢件列表",
  LostPieces: "丢件",
  CorrectDeliveryCost: "更正配送费",
  Sync: "同步",
  InsufficientBalance: "余额不足",
  createIncomeBill: "创建收入账单",
  costRule: "成本规则管理",
  rule: "规则",
  object: "对象",
  User: "用戶",
  childOrder: "子单号",
  other_fee: "杂费明细",
  other_fee_hq: "杂费明细",
  reserve_number: "预约号",
  carton_nums: "纸箱数量",
  suject: "科目",
  newAirWaybillN: '新建空运提单(新)',
  entrust: '委托',
  businessUser: '业务员',
  liquid: '是否液体',
  warehousingNumberManagement: '入仓号管理',
  warehousingNumber: '入仓号',
  warehousingInformation: '入仓信息',
  batch_number: '批次号',
  warehousing: '货物入仓',
  lost_rate: '丢件率',
  billingStatus: '计费状态',
  accepted: '已接收',
  PendingWriteOff: '待核销',
  skipServiceCheck: '跳过客服审核',
  causeDescription: '原因说明',
  hw_surcharge: '海外附加费规则',
  CustomsHold_t: "海关扣件",
  CustomsHoldRate_t: "海关扣件率",
  shipment_hq1: "小包出货明细(新版)",
  receivableTotal: '应收合计',
  epidemic: '疫情',
  subtotal: '小计',
  WeightAfterUsingCarton: '使用纸箱后的重量',
  VolumnAfterUsingCarton: '使用纸箱后的体积',
  Rule: '录入规则',
  Single: '录入单条',
  AmountBetween: '金额均摊',
  ChargingReassignment: '计费重分摊',
  AgentContract: '代理合同',
  Invalid: '作废',
  destroy_rate: '销毁率',
  forecast: "预报",
  transactionNumber: "交易号",
  MarkAbnormal: '标记异常',
  Dimension: '维度',
  def: '默认',
  b2b_charging_type: 'B2B报价计费类型',
  field: '字段',
  deliveryService: '送仓服务',
  Delivery: '送仓',
  LabelsNeedReplaced: '需要换标',
  labelIsReplaced: '完成换标',
  WarehouseOut: '出仓',
  CargoLabel: '货件标签',
  SkuLabel: 'SKU标签',
  PDFFile: 'PDF文件',
  Change: '换',
  clearanceQuotationRule: '清关报价规则',
  endTime: '结束时间',
  transport_fee: '转移费',
  billingVAT: '计费VAT',
  deliveryAgentSwitch: '派送代理切换',
  endTripIncomeBill: '尾程收入账单',
  NextProcessing: '下一步处理环节',
  takenMode: '收取方式',
  fullPrice: '全价',
  halfPrice: '半价',
  outboundCtns: '出库数量',
  CODServiceCharge: '到付手续费',
  CODFee: '到付手续费',
  Inboundpcs: '入库数量',
  HSCode: '商品编码',
  SKUBarcode: '商品编码',
  CODCurrency: '到付货币代码',
  CODAmount: '到付金额',
  UnpackedFinished: '是否拆包完成',
  UnpackedFinished1: '是否拆包完成',
  ConfirmedWeight: '是否确认重量',
  B2BECommerce: '是否电商杂货渠道',
  ValueAddedServiceFees: '增值服务费用',
  InboundWarehouse: '入库仓库',

  "Excel Batch add": "批量添加导入",
  "Pending create order": "待生成订单数量:",
  "Finish time": "最后生成订单时间:",
  "Transport info": "运输信息",
  "Goods Info": "货物信息",
  "Carton No.": "箱号备注",
  "Other Remark": "其他备注",
  "Other Info": "其他信息",
  "Customs Declaration": "买单报关",
  "Document Declaration": "代理报关",
  "Document Set": "单证数量",
  "Quotation Info": "报价信息",
  "Export Details": "导出明细",
  "Pre-view price": "预览报价",
  "choose price": "请选择报价",
  "setup the fixed price": "设置默认报价",
  "Item collection": "计费类型(必填)",
  "Currency": "货币代码(必填)",
  "Revise  CTNS": "修改件数",
  "Upload doc": "上传文件",
  "The delivery type": "发货类型",
  "Contact person": "上门提货联系人",
  "pick up address": "上门提货地址",
  "Download Address": "下载地址",
  "Reject": "审核不通过",
  "Excel doc": "Excel文件",
  "Process Info (CN)": "轨迹中文描述",
  "Consignee Address": "收件人地址",
  "Consignee Phone": "收件人电话",
  "ConsigneeTel": "收件人备用电话",
  "Total Product quantity": "商品总数量",
  "Update time": "解决方案回传时间",
  "Company name": "客户公司中文名",
  "Refund Reason": "退货退款原因",
  "Refund Amount": "退款账单金额",
  "Refund Currency": "退款币种",
  "wheather cancel pick up": "是否取消取件",
  "photo": "商品图片",
  "Aliexpress code": "速卖通 ID",
  "Agent process status": "代理处理状态",
  "DTO": "是否退货取件",
  "customer process time": "客户处理时间",
  "return day": "退回天数",
  "Inbound manifest": "入库单号",
  "Non Battery": "未带电明细",
  "Skip quote details": "跳转报价详情",
  reuiqre2: '(必填)',
  'operation time': '操作时间',
  'taxationType': '税收类型',
  'WarehouseOutTime': '出仓时间',
  'Warehouse Remark': '仓库备注',
  'SKU Barcode': '商品编码',
  'Customer service Handler': '提交方案客服',
  'Receiving Warehouse CTNS': '仓库接收件数',
  'Customer forecast CTNS': '客户预报件数',
  'Receiving Warehouse quantity': '仓库接收数量',
  'Customer forecast quantity': '客户预报数量',
  'Shipper Remark': '客户备注',
  'Tracking number': '运单号',
  'intercept': '拦截订单',
  'Update Status Time': '更新状态时间',
  'Update Status': '更新状态',
  'Pickup Time': '取件时间',
  'Pickup User': '取件人',
  'pickup': '取件列表',
  'Process Info Time': '轨迹描述时间',
  'TaxRules': '税费规则',
  ReceiptSignReceipt: "签收单回执",
  High: "高",
  Low: "低",
  DeliveryMethod: '配送方式',
  Part: '部分',
  tagService: '换标服务',
  shippingMarkLabelReplacedFile: '箱唛换标文件',
  SKULabelReplacedFile: '换标文件',
  SKULabelReplacedInfo: '换标信息',
  dduShipment: "DDU 出货明细",
  tracker_time: '轨迹时间',
  totalFee: '总费用',
  SettlementAgent: '对代理结算',
  SettlementCustomers: '对客户结算',
  SettlementStatus: '结算状态',
  calculationTime: "计算时间",
  SettlementObject: "结算对象",
  Customer: "客户",
  OutboundRemarks: "出库备注",
  dduBill: "DDU 账单",
  OriginalFee: "原费用",
  TargetSettlementFee: "目标结算费用",
  TotalAmountReceivable: "应收总金额",
  "Excel Import": "Excel 导入",
  "FBA Number": "FBA 号",
  "Upload File": "上传文件",
  "Air Agency Time": "交航空代理时间",
  "Clearance Start Time": "清关开始时间",
  "Confirm Upload file": "确认上传文件",
  "Old FBA Number": "原FBA号",
  "New FBA Number": "新FBA号",
  "Old SKU": "原SKU",
  "New SKU": "新SKU",
  "SKU Number": "新SKU",
  "Cancel Confirm": "取消确认",
  "Delete Bills": "删除账单",
  "Change Target Currency Rate": "转目标货币的汇率",
  "Old FBA Number": "原 FBA 号",
  "New FBA Number": "新 FBA 号",
  "Old SKU": "原 SKU",
  "New SKU": "新 SKU",
  "Batch Upload": "批量上传",
  "Storage Charges": "仓租",
  "Number Charges": "收费计数",
  "Charges Unit": "计数单位",
  "Transit Time": "转运时间",
  "Transit Destination": "转运目的地",
  "Delivery Time": "送仓时间",
  "Delivery Type": "送仓类型",
  "DD Type": "DD类型",
  "all empty": "不能全部为空",
  "Expense Item": "收费项目",
  "Stroage Days": "存储天数",
  "Charge Mode": "计费方式",
  "Charge Total Amount": "计费总额",
  "Confirm Freight": "确认报价",
  "Company name": "公司名称",
  "Total qyt": "商品总数量",
  "Upload Appointment Number Doc": "上传预约号附件",
  "Appointment delivery Date": "派送日期",
  "Appointment delivery Time": "派送时间",
  "Abnormal Message": "异常信息",
  ReceiptSignReceiptDownload: "签收单回执下载",
  whetherFreight: "是否报价",
  other_fee_bill: "杂费账单",
  offerer: "报价人",
  QuotationConfirmTime: "报价确认时间",
  "Old FBN Number": "原 FBN 号",
  "New FBN Number": "新 FBN 号",
  finished: "已完成",
  unfinished: "未完成",
  "Delivery warehouse": "派送仓库",
  "unconfirmed": "待确认",
  "Whether Outbound": "是否出库",
  "Association Service": "关联客服",
  "customExport": "自定义导出",
  SettlementFee: "结算费用",
  downloadReceipt: "下载签收单",
  downloadEnclosure: "下载附件",
  waiting: "等待中",
  refresh: "刷新",
  deliveryWarehouse: "送仓仓库",
  messageBoard: '留言列表',
  other_fee_bill_hq: '杂费账单',
  edit: '编辑',
  Area: '区域',
  oldCity: '旧收件城市',
  oldConsigneeAddress: '旧收件地址',
  TotalVATAmount: '总VAT金额',
  title_cn: '中文标题',
  title_en: '英文标题',
  content_cn: '中文内容',
  content_en: '英文内容',
  faq: '常见问题',
  TrackAssociation: '关联轨迹',
  to_bhd: '巴林第纳尔',
  to_omr: '阿曼里亚尔',
  to_iqd: '伊拉克第纳尔',
  to_ils: '以色列新谢克尔',
  to_jod: '约旦第纳尔',
  WhetherPayFreight: '是否支付运费',
  UploadFreightAudit: '上传运费审核',
  TransitionSettlementCurrency: '转换结算货币',
  ActualAmountRefund: '实际应退金额',
  FinalActualAmountRefund: '最终实际应退金额',
  refundCod: '退账单',
  OtherAccountReceivable: '其他应收账单',
  ConvertedCurrencyObject: '转换货币对象',
  ConvertedCurrency: '转换货币',
  HedgingAmount: '对冲金额',
  draft: '草稿',
  waitConfirm: "待审核",
  rejected: "审核不通过",
  fastening: '剔除订单',
  beijing_time_difference: '北京时间',
  differenceDay: '请确认时间是否为：',
  WhetherBilling: '是否计费',
  quoteDetails: '报价详情',
  BillPreview: '账单预览',
  customerCityMapping: '客户城市映射',
  ClientCityName: '客户城市名称',
  evidenceHistory: '举证记录',
  evidenceTime: '举证时间',
  evidenceFile: '举证文件',
  diff_weight: '重量差异',
  Body: '整体',
  overseasInboundTime: '海外到仓时间',
  'Match old system order': '匹配旧系统单',
  'Old system order': '旧系统单',
  SupportCod: "是否支持cod",
  DeliveryFailReason: "送仓失败原因",
  ReturnDescription: "退回描述",
  branch_cod_new: "分公司COD明细（新版）",
  branch_cod_refund_new: '分公司COD应退（新版）',
  multiplePackageShipment: '商业快递',
  repository: '知识库',
  'Delivery Party Forecast': '地派预测',
  'Forecast Result': '地派结果',
  'deliveryAging': '派送时效',
  'operation content': '操作内容',
  'detailedAddress': '详细地址',
  'Min Extent': '最小区间',
  'Max Extent': '最大区间',
  halfPriceParams: '半价参数',
  minimum: '最小值',
  maximum: '最大值',
  specifyAmount: '具体金额',
  quotationName: '报价名称',
  chargeRule: '收费规则',
  freeShipping: '免运费',
  fixedAmount: '固定金额',
  TaxesUnitPrice: '税费单价',
  TO_WMS: "转海外仓",
  deliveryPartyForecast: '地派预测',
  Forecast: '预测',
  'Forecast Result': '预测结果',
  'Weigh more than': '重量大于',
  labelIsReplacedDoneFile: '换标完成文件',
  labelIsReplacedDoneFileBatchDownload: '换标完成文件批量下载',
  clearance_done_date: "清关完成时间",
  Replenish: "补充说明",
  VATRate: "VAT比例",
  ttParcelForecast: "TT包裹预报",
  declaredWeight: "申报重量",
  file_name: "文件名称",
  expectPickUpStartTime: "期待揽收开始时间",
  expectPickUpEndTime: "期待揽收结束时间",
  VnlinWeight: "合联重量",
  alreadyInboundQuantity: "已入库数量",
  NotInboundQuantity: "未入库数量",
  UploadEvidenceFile: "上传举证文件",
  UploadlabelIsReplacedDoneFile: "上传换标完成文件",
  childOrderPcs: '子单号个数',
  podSettlement: 'POD结算',
  WeightType: '重量类型',
  FreightVAT: "运费VAT",
  channel_english_name: '渠道英文名称',
  versionUpdate: '系统版本更新提醒',
  whetherUpdatePage: '是否更新页面?',
  batchDelivery: '批量发货',
  packetDeliveryCost: '小包派送成本',
  PODType: '签收类型',
  branch_cod_list_new: "COD应收账单(新)",
  ModificationCost: "修改成本",
  'Threshold Values': '申报价值门槛',
  'Duty Rate': '关税比例',
  'Paper Fee': '资料费/票',
  'Clearance Fee': '清关费/票',
  'Billing Weight': '计费重量',
  'tracking order': '单号',
  'Arrived delivery Hub': '到仓',
  'Arrived delivery Hub Rate': '到仓率',
  'Pending delivery': '待出派',
  'Pending delivery rate': '待出派率',
  'USD To Destination Currency Rate': '美金转目的国货币汇率',
  'auto bind': '自动绑定',
  'Total Quantity': '总数量',
  'Total Ctns': '总件数',
  'Pening outbound': '未出库票数',
  'wheather finished outbound': '是否完全出库',
  'MAWB NO.': '提单号',
  'WAbnormal': '是否异常',
  'abnormal bills': '异常票数',
  'warehouse remark': '库存备注',
  'finish time': '完成时间',
  'Upload': '未上传',
  'No Upload': '未上传',
  'Delivery Fail Params': '派送失败参数',
  'Set Label': '设置标签',
  'DeliveryMode': '派送方式',
  'Fold': '折',
  'no discount': '无折扣',
  'Assign SMSA': '是否指定SMSA',
  'Assign JT': '是否指定JT',
  'Assign Smile': '是否指定iMile',
  'AssignAgent': '绑定代理名称',
  Battery: '带电',
  uploading: '上传中',
  uploadFail: '上传失败',
  batchBind: '批量绑定',
  'search criteria cannot be empty': '搜索条件不能为空',
  'PCS Count': 'PCS数',
  'PCS Count': 'PCS数',
  'Document Cameras': '高拍仪',
  'Start uploading': '开始上传',
  'gather': '采集',
  'gatherSuccess': '采集成功',
  'Imprest': '备用金',
  'applyImprest': '申请备用金',
  'applyTitle': '申请标题',
  'applyReason': '申请原因',
  'applyAmount': '申请金额',
  'proposer': '申请人',
  'applyDepartment': '申请部门',
  exportRecords: "导出记录",
  ElapsedTime: "耗时",
  ImprestBalance: "备用金余额",
  QuotationRemarks: "报价备注",
  vatFee: "VAT明细",
  miscellaneousQuotation: '杂费报价匹配',
  quotationStatus: '报价状态',
  quotationTime: '报价时间',
  AlreadyQuotation: '已报价',
  notQuotation: '未报价',
  Created: '已生成',
  notCreated: '未生成',
  reimburseStatement: '报销流水',
  vatBill: 'VAT账单',
  circuit: '派送线路',
  systemDeliveryParty: '系统地派',
  LabelWatermark: '面单水印',
  aterialIntercept: '物料拦截',
  InterceptRemarks: '拦截备注',
  DestinationCity: '目的城市',
  "Revise Transport Mode": "修改运输方式",
  "Fixed USD": "固定美金",
  "Destination Currency": "目的国货币",
  "Administration fee": "管理费",
  "Declared Currency Type": "申报值货币类型",
  storageBill: "仓储费用账单",
  billingStartTime: "计费开始时间",
  billingEndTime: "计费结束时间",
  ECommerce: "电商杂货",
  printLabel: '打印面单',
  startPrint: '开始打印',
  SystemDefault: '系统默认',
  pushTMS: '推送TMS',
  branch_storage_fee: '仓储费用明细',
  branch_storage_bill: '仓储费用账单',
  AgentDeliveryAllowed: '允许代理派送',
  'master bill number': "主单号",
  'child  bill number': "子单号",
  'Order channel': "下单渠道",
  'service remark': "客服备注",
  'branch_other_fee': "杂费明细",
  'rejection_boxno': "拒收箱号",
  'tt_track': 'TT轨迹监控',
  'Tracker Status': '轨迹状态',
  'Tracker ID': '轨迹ID',
  'Occurred Time': '发生时间',
  'Input Time': '录入时间',
  'input channel': '录入渠道',
  'Push Error Count': '错误次数',
  'Start Push Time': '开始推送时间',
  'Push Status Time': '推送状态时间',
  'Push Status': '推送状态',
  'Synchronizing': '同步中',
  'Manual Intervention': '人工干预',
  other_fee_hq_new: '杂费明细(新)',
  'Finance of Guangzhou Hq (Freight: small bag)': '广州总部财务（运费：小包）',
  'Finance of Guangzhou Hq (Freight: Shuangqing)': '广州总部财务（运费：双清）',
  'Finance of Guangzhou Hq (COD)': '广州总部财务（COD）',
  BillingInterval: "计费区间",
  'Push duration': "推送时长",
  'batch update PLInvoice': '批量上传箱单,发票',
  'Branch financial supervisor': '分公司财务主管',
  'Branch financial accountant': '分公司财务会计',
  'Discounts Setting': '折扣设置',
  'deadline': '时限管理',
  'deadlineDay': '时限天数',
  'Shelf type': '上架类型',
  'Duration Time': '用时',
  'Intercept Count': '拦截次数',
  'data sources': '数据来源',
  'individual traveler': '散客',
  'clientConfig': '客户配置',
  userInfoStr2: "轨迹推送接口",
  userInfoStr3: "轨迹回滚接口",
  authorization: "秘钥",
  WhetherAlreadyOperation: "是否已操作",
  halfPriceSetting: '半价设置',
  SyncOrderTemplate: '同步下单模板',
  BillingMethod: '收费方式',
  freightRata: '运费比例',
  'Fixed amount per ticket': '每票固定金额',
  'PODTime': 'POD时间',
  'Fixed amount currency per ticket': '每票固定金额货币',
  'Reimbursement type': '报销金类型',
  'bank deposit': '银行存款',
  'Reimbursement slip number': '报销流水单号',
  'Reimbursement type': '报销类型',
  'Cost details': '费用详情',
  'Reasons for reimbursement': '报销原因',
  'Currency of application': '申请币种',
  'System notification phone': '系统通知手机',
  'Bagging failure reasons': '装袋失败原因',
  'error of replication': '重量误差',
  priceRule: '价格规则管理',
  otherQuotation: '杂费报价规则',
  RuleDetails: '规则详情',
  'Customer quotation rule': '客户报价规则',
  'Charging remarks': '计费备注',
  'formula mode': '计算方式',
  "special_claim": "特殊理赔",
  "Follow up customer service": "跟进客服",
  "Freight currency": "运费币种",
  "freight amount": "运费金额",
  "Scheme amount": "方案金额",
  "Scheme Scheme": "方案描述",
  "Transfer Order": "转运单",
  "Total bag count": "袋子总数",
  "Whether enter weight information": "是否录入重量信息",
  "Shelf days": "上架天数",
  "System Inform Email": "系统通知邮箱",
  "transfernew": "新建中转单",
  "Whether Unpack": "是否开箱",
  "Personal information not bound warehouse": "个人信息没有绑定仓库",
  "transportAirport": "转运机场",
  "Arrival track": "到港轨迹",
  "Outgoing track": "出库轨迹",
  "money receiving QR code": "收款码",
  "TT take down instruction": "TT下架指令",
  "Take down instruction date": "下架指令日期",
  'unboxList': '开箱列表',
  "smsList": "短信列表",
  "smsContent": "短信内容",
  "Send Time": "发送时间",
  "Send Status": "发送状态",
  "Robot ID": "机器人ID",
  "WeCom Robot": "企微机器人",
  'setting Unpack': '设置开箱',
  'Operation fee charging mode': '操作费收费模式',
  'Registration link': '注册链接',
  'podBill': '海外特殊POD账单',
  addHistory: "上下架记录",
  orderTrack: "订单轨迹",
  Create: "创建",
  task: "任务",
  unblock: "解除拦截",
  LabelMiniNoInvoice: "面单(100*100无发票)",
  printing: "打印中",
  printingTip: "数据量大时，请耐心等待，勿操作其他！",
  clearance_end_date: "清关结束时间",
  scanInboundDate: "扫描入库时间",
  'Source name': "别称",
  'balance': "余额",
  'dduRule': "DDU税费规则",
  'error create order': '失败订单数量',
  'warehouse receive number': '仓库接收数量',
  'Verification method': '核销方式',
  'Offline verification': '线下核销',
  'Online verification': '线上核销',
  'Reimbursement method': '报销方式',
  'Reimbursement time': '报销时间',
  'Delivery Sheet': '派送单',
  'b2BToB2COrder': 'B2B转B2C订单',
  'createB2BToB2C': '创建B2B转B2C订单',
  collectingMoney: "货款代收",
  numberParcels: "包裹件数",
  clientCompany: "收件公司",
  shipperName: "收件人姓名",
  Email: "邮箱",
  order_address: "收货地址",
  short_address: "短地址",
  'Product Name': "英文商品名称",
  'Gross Weight': "商品毛重",
  'SKU Barcode': "商品Sku码",
  order_goods: "商品数量",
  cityArea: '城市区域',
  cityCircuit: '城市线路',
  cityAlias: '城市别名',
  First: '头程',
  'Total charged weight': '总计费重',
  'Internal audit comments': '内部审核备注',
  'Push customer comments': '推送客户备注',
  'Completed': '已完结',
  'Collect warehouse fees': '收取仓库费用',
  'board_number': '板号',
  'Alipay order number': '支付宝订单号',
  'Associated Order': '关联单号',
  'deliveryCostQuoteRule': '派送成本报价规则',
  'Step': '步进',
  'podRollback': '订单回滚',
  'trackRollback': '轨迹回滚',
  'Location': '地点',
  'Delivery Driver Phone': '派送司机电话',
  clearanceCostQuoteRule: '清关成本报价规则',
  'Trailer fee': '拖车费',
  b2bCostQuoteRule: 'B2B成本报价规则',
  'no order': '未下单',
  storageCostQuoteRule: '仓储成本报价规则',
  'Display shipper': '显示发件人',
  storageOperateQuoteRule: '仓储操作报价规则',
  BigBag: '大包',
  dataBoard: '数据看板',
  Evidence: '举证',
  'Expired quotation': '已过期报价',
  'Expiring soon quotation': '{1}天即将过期的报价',
  lingyang: '羚羊分包',
  Arrive: '到齐',
  arrive: '抵达',
  Total1: '总数',
  endTrip1: '尾程',
  storageFeeQuoteRule: '仓储费用报价规则',
  'WAIT': '待到货',
  'TAIL': '已到货',
  'POD': '已完结',
  'BoardCargo': '板货',
  'unblockIntercept': 'TMS解除拦截',
  'fordelQuoteRule': 'B2B自动报价规则',
  'transportFee': '运输费',
  'groceries': '杂货',
  'Unloading fee': '卸货费',
  'Combine Packages Fee': '合包费',
  'Load Cabinet': '装柜',
  'Last update time': '最后更新时间',
  'Sales team': '销售团队',
  '@Phones': '@成员的手机号',
  'Expense subject': '费用科目',
  'Please complete the form': '请完善表格',
  'printer': '打印机',
  'doorToDoor': '门到门服务',
  'Remote degree': '偏远程度',
  'emergencyKit': '应急工具包',
  'tmsInbound': 'TMS入库',
  'accurate': '精确',
  'password': '密码',
  'Pending callback': '待回调',
  'Waybill': '运单',
  'output_port': '分拣口',
  'SA': '沙特',
  'AE': '阿联酋',
  'changeOrderList': '换单列表',
  'New order number': '新单号',
  'Service fees': '服务费用',
  'Label change': '换标',
  'Tip': '提示',
  'Channel': '渠道',
  'Site': '站点',
  'Warehousing': '入仓',
  'In warehouse': '在仓',
  'Total volume': '总体积',
  'Carton': '纸箱',
  'Mixed': '混装',
  'High tax types': '高额税费类型',
  'High tax and fee billing rules': '高额税费计费规则',
  'Minimum tax collection point': '最低收税点',
  'MANIFEST FEE Types': 'MANIFEST FEE类型',
  'MANIFEST FEE Calculation Rules': 'MANIFEST FEE计算规则',
  commissionManagement: '提成管理',
  businessCommissionConfig: '业务提成配置',
  'Valid period': '有效期',
  'International': '国际',
  'Local': '本地',
  'China to Israel': '中国到以色列',
  'Customs clearance': '双清',
  'Profit ratio': '利润比例',
  'Team Management': '团队管理',
  'interest rate': '利率',
  'commissionDetails': '提成明细',
  'Commission': '提成',
  'Middle East': '中东',
  'Israel': '以色列',
  'Manage': '管理',
  'whole course': '全程',
  'Whole board': '整板',
  'Pending Billing': '待计费',
  'storageFeeNew': '库位明细(新)',
  'locationDetailsNew': '库位明细(新)',
  'detail data': '明细数据',
  'segmentDetails': '分段明细',
  'Tax': '税',
  'overseasHolidays': '海外节假日',
  'Holidays': '节假日',
  'Detection': '检测',
  'Today': '今天',
  'Monday': '周一',
  'Tuesday': '周二',
  'Wednesday': '周三',
  'Thursday': '周四',
  'Friday': '周五',
  'Saturday': '周六',
  'Sunday': '周日',
  'inboundNotBagged': '入库未装袋',
  'segmentBill': '分段账单',
  'workOrderManagement': '工单管理',
  'workOrderType': '工单类型',
  'Work Order': '工单',
  'Reply': '回复',
  'Parent': '父级',
  'Shipping Order Number': '出货单号',
  'workOrderList': '工单列表',
  'ttPackageCollection': 'TT包裹揽收',
  'Collect': '揽收',
  'Collectors': '揽收人',
  'Work order number': '工单号',
  'Regional zoning': '地区分区',
  'Not partitioned': '不分区',
  'Payment': '打款',
  'Urban zoning': '城市分区',
  'partition': '分区',
  'Please search for a country before proceeding': '请先搜索国家后再进行操作',
  'Package': '包裹',
  'tm_track': 'TM轨迹监控',
  'No charge': '不收费',
  'abnormalArrivalTrajectory': '到仓轨迹异常',
  gccOrderStatistics: 'GCC订单统计',
  'Platform Product Info': '平台货物详情',
  goodsIdPlaceholder: '商品ID为11位or16位的纯数字',
  'closed loop': '闭环',
  'Picking1': '提货',
  'for short': '简称',
  'frequency': '频次',
  'Transfer': '中转',
  tmClosedLoop: 'TM闭环',
  latest: '最迟时间',
  MainStatus: '主状态',
  trackerMainStatus: '轨迹主状态',
  Limit: '额度',
  Billing1: '开票',
  'material': '资料',
  'Recorded': '入账',
  'With or Without': '有无',
  'billingRecord': '开票记录',
  'Please enter the local time': '请录入当地时间',
  Single1: '单',
  Bank1: '银行',
  previously: '以前',
  riskControl_new: '额度风控(新)',
  'manual rec': '调账',
  deliveryStatistics: '送仓统计',
  b2borderStatistics: 'B2B订单统计',
  proportion: '占比',
  customerClearanceEndTripBill: '客户清关尾程提单',
  History: '历史记录',
  'AFR Intern': '空运部',
  'Platform Group': '平台组',
  'operating': '操作中',
  'offerBill': '出账单',
  'Delivered': '已送',
  'Residue': '剩余',
  'Total2': '总',
  'Temporary duration': '暂存时长',
  'temporaryStorageOverseas': '暂存海外仓',
  'exportManager': '导出管理',
  'isolation': '隔离',
  'Overrun': '超期',
  overseasShelve: '海外仓上架',
  'skuPcs': 'SKU数量',
  'Operate Time': '开始上架时间',
  'Complete Time': '上架完成时间',
  'Async': '异步',
  'Pre': '上一个',
  adjustBillRecord: '调账记录',
  detail3: '明细',
  orderTimeoutInspection: '订单超时检验',
  Inspection: '检验',
  'Combined display': '合并展示',
  'contractTitleAndAgreement': '合同抬头和协议',
  'Card No': '银行卡号',
  'Alipay Pay': '支付宝支付',
  'WeChat Pay': '微信支付',
  'otsCityMapping': 'OTS城市映射',
  'Clearance delivery bill': '清派提单',
  'missingTrackMonitor': '缺失轨迹监控',
  'missing': '缺失',
  'Complete section': '全段',
  'Clearance delivery': '清派',
  'Concern Extent': '关注程度',
  'billFirstAnalysis': '提单头程时效',
  'Arrive': '到达',
  'Prefix': '前缀',
  'Airline': '航司',
  'financialRevenue': '财务收入',
  'Order Quantity': '单量',
  'Affiliation': '归属',
  'Shipment': '出货',
  'gross profit': '毛利',
  'gross profit rate': '毛利率',
  'Average': '平均',
  'Trace': '线路',
  'Split': '拆段',
  'timeoutOrder': '超时订单',
  tmTrackWarning: 'TM轨迹预警',
  Coefficient: '系数',
  Ultimately: '最终',
  DifferenceRate: '差异率',
  'TEMU CCD TO FIRST': 'TEMU拆段转专线',
  Dendrogram: '树状图',
  'Ranking List': '排行榜',
  'Rank': '排序',
  'Display': '展示',
  'Ranking': '排行',
  'Transit Port Order': '过港单',
  'Harbour Mark': '过港标',
  analysisReturnException: '退件异常列表',
  agentExceptionList: '代理异常列表',
  'Default payment': '默认回款',
  'Re-audit after N days': '过N天重新审核',
  'Please go to Export management download': '请到导出管理下载',
  ttForecastInfo: 'TT预报信息',
  'Small charged mark': '小带电标',
  timeoutOrderStatistics: '超时订单统计',
  level: '等级',
  Settlement: '结算',
  cityParition: '城市分区',
  'fs_name': '商品备注',
  percents: 'P占比',
  allowCategory: '可走品类',
  b2bCosting: 'B2B销售成本规则',
  b2bDeliver: 'B2B派送费成本规则',
  b2bSalesmanBill: 'B2B销售成本账单',
  shipment_costing: '小包出货成本',
  saMockPackage: '沙特拆包',
  dduTracker: '轨迹同步',
  pushECO: '推送ECO(B2B)',
  offset: '时间偏移',
  dunhuangData: '敦煌数据查看',
  doubleSummary: '客户账单',
  shipment_hq_costing: '小包出货明细（销售）',
  other_fee_hq_quotation: '杂费应收',
  dispatchShipment: '手动分货'
};
